<div class="card-loading">
    <div class="loader"></div>
</div>